import { acceptHMRUpdate, defineStore } from 'pinia';

export const useContractsStore = defineStore('contracts', {
  state: () => ({
    lastSyncMasterData: '',
    lastSyncEntities: '',
  }),

  persist: true,
});

if (import.meta.webpackHot) {
  import.meta.webpackHot.accept(acceptHMRUpdate(useContractsStore, import.meta.webpackHot));
}
